import { Check } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { Reveal, Eyebrow } from "@/components/site/Motion";
import { QuoteButton } from "@/components/site/Nav";
import { Marquee } from "@/components/site/Marquee";
import { CTA } from "@/components/site/CTA";

const BLOCKS = [
  { e: "Fee elimination", t: "Stop paying to accept cards.", d: "Our fee elimination programs are designed to remove transaction fees from your bottom line, set up compliantly and explained clearly to your customers.", pts: ["Compliant, customer-friendly setup", "Signage and receipts handled", "Guided by your account manager"], img: "/img/tap.jpg" },
  { e: "Equipment", t: "Free hardware for qualifying merchants.", d: "From countertop terminals to mobile readers and full POS systems, we match you with equipment that fits how you sell.", pts: ["Countertop & wireless terminals", "Mobile and tap-to-pay readers", "Smart POS for restaurants & retail"], img: "/img/terminal-blue.jpg" },
  { e: "Online payments", t: "Sell online and over the phone.", d: "Accept payments on your website, send invoices, or key in card-not-present orders with a virtual terminal.", pts: ["Website checkout gateways", "Invoicing & payment links", "Virtual terminal"], img: "/img/phone.jpg" },
  { e: "Support", t: "People who pick up the phone.", d: "Every merchant gets a dedicated account manager, plus tech support and customer service teams that know your account.", pts: ["Dedicated account manager", "Tech support for your equipment", "Transparent, plain-English pricing"], img: "/img/owners.jpg" },
];

export default function Solutions() {
  return (
    <div data-testid="solutions-page">
      <PageHero eyebrow="Solutions" lines={["Processing that", "pays you back."]} sub="Every tool you need to accept payments, in store, on the go and online, backed by people who know your business." img="/img/pos.jpg" />
      <Marquee />
      <section className="bg-white px-4 py-24 sm:px-6 lg:px-12 lg:py-32">
        <div className="mx-auto max-w-7xl space-y-24 lg:space-y-32">
          {BLOCKS.map((b, i) => (
            <div key={b.e} id={b.e.toLowerCase().replace(/\s+/g, "-")} className="grid scroll-mt-32 items-center gap-10 lg:grid-cols-2 lg:gap-20" data-testid={`solution-block-${i}`}>
              <Reveal className={i % 2 ? "lg:order-2" : ""}>
                <div className="overflow-hidden rounded-[2rem]">
                  <img src={b.img} alt={b.e} className="aspect-[5/4] w-full object-cover transition-transform duration-700 hover:scale-105" />
                </div>
              </Reveal>
              <Reveal delay={0.1}>
                <Eyebrow>{`0${i + 1} / ${b.e}`}</Eyebrow>
                <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl">{b.t}</h2>
                <p className="mt-5 max-w-lg text-emerald-950/75">{b.d}</p>
                <ul className="mt-8 space-y-3">
                  {b.pts.map((p) => (
                    <li key={p} className="flex items-center gap-3 font-medium"><span className="grid h-6 w-6 place-items-center rounded-full bg-lime-400"><Check className="h-3.5 w-3.5" strokeWidth={3} /></span>{p}</li>
                  ))}
                </ul>
                <QuoteButton testid={`solution-quote-btn-${i}`} dark className="mt-10" />
              </Reveal>
            </div>
          ))}
        </div>
      </section>
      <CTA />
    </div>
  );
}
